// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logout-button {\n  align-self: flex-end;\n  margin: 8px;\n}\n", "",{"version":3,"sources":["webpack://./src/generic/logout/Logout.less"],"names":[],"mappings":"AAEA;EACC,oBAAA;EACA,WAAA;AADD","sourcesContent":["@import '@kallidus/common/less/spacing-scale.less';\n\n.logout-button {\n\talign-self: flex-end;\n\tmargin: @spacer-desktop-02;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
